<div [ngClass]="{'standAlone': standAlone }">
  <h4 class="no-margin-bottom">Task - {{ selectedItem.title }}</h4>
  <p>Assigned by: {{ workOrderCreator?.firstName }} {{ workOrderCreator?.lastName }}</p>

  <h5 class="no-margin-bottom">Details</h5>
  @if (selectedItem.targetUrl) {
    <a [href]="selectedItem.targetUrl">Linked Work Item</a>
  }
  <p [innerHTML]="selectedItem.description | safeHtml"></p>

  @if (isAdhoc && !isComplete) {
    <div class="detail">
      <button class="button float-right" (click)="markComplete()">Complete Task</button>
    </div>
  }
</div>

